<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <div class="d-flex">
        <h3 class="mb-0">Referrals</h3>
        <div v-if="selectedRows.length" class="ml-auto">
          <base-button
            size="sm"
            type="light"
            @click="$emit('generate-credit-note', selectedRows)"
          >
            <i class="fas fa-file-invoice"></i> Generate Credit Note
          </base-button>
        </div>
      </div>
      <transition name="fade"> </transition>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      empty-text="No Referrals"
      :data="referrals"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" :selectable="selectable">
      </el-table-column>
      <el-table-column label="Referral" min-width="120px" prop="email" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <a
                :href="`https://www2.chinesepod.com/marketingcenter/users/index/view?user_id=${row.id}&site_id=2`"
                title="CRM Link"
              >
                <span class="font-weight-600 name mb-0 text-sm text-break">{{
                  row.email
                }}</span>
              </a>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Date" min-width="190px" prop="createdAt" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="">
              <span class="mb-0 text-sm">{{
                new Date(row.createdAt).toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  timezone: 'UTC'
                })
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Event"
        min-width="190px"
        prop="event_type"
        sortable
      >
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="">
              <span class="mb-0 text-sm text-capitalize">{{
                row.event_type
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Fee" min-width="190px" prop="event_type" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="">
              <span class="mb-0 text-sm"
                >${{ `${Number(row.event_fee).toFixed(2)}` }}</span
              >
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Fee Status"
        min-width="190px"
        prop="status"
        sortable
      >
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="font-weight-600 mb-0 text-sm text-capitalize">{{
                row.invoice
                  ? `${row.invoice.status} - ${row.invoice.id}`
                  : 'Outstanding'
              }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Details" min-width="80px" prop="event_details">
        <template v-slot="{ row }">
          <div class="align-items-center">
            <base-button
              type="secondary"
              size="sm"
              class="btn-sm btn-icon-only"
              @click="eventDetails(row.event_details)"
              ><i class="fas fa-eye"></i
            ></base-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <modal
      :show.sync="modal"
      modal-classes="modal-secondary"
      @close="modal = false"
    >
      <div slot="header" class="text-center">
        <h2 class="text-uppercase text-center">Event Information</h2>
      </div>
      <div v-for="key in Object.keys(details)" :key="key" class="text-center">
        <h3 class="text-capitalize">{{ key }}</h3>
        <div v-if="typeof details[key] === 'object'">
          <div v-for="item in Object.keys(details[key])" :key="item">
            <div v-if="typeof details[key][item] === 'object'">
              <h5 class="text-capitalize">{{ item }}</h5>
              <div v-for="(i, key) in details[key][item]" :key="key">
                <div v-if="i">
                  <h6>{{ key }}</h6>
                  <h6>{{ i }}</h6>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="details[key][item]">
                <h5 class="text-capitalize">{{ item }}</h5>
                <div>{{ details[key][item] }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          {{ details[key] }}
        </div>
      </div>
      <template slot="footer"> </template>
    </modal>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from 'element-ui'

export default {
  name: 'ReferralTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    referrals: Array
  },
  data() {
    return {
      modal: false,
      details: {},
      selectedRows: []
    }
  },
  methods: {
    selectable(row, index) {
      return !row.invoice
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    eventDetails(event) {
      this.details = Object.assign({}, event)
      this.modal = true
    }
  }
}
</script>

<style scoped></style>
